export default "__VITE_ASSET__B7E8SaKb__"